import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ISiteBoxDocumentConfig } from '@core/entities/SiteBoxDocumentConfig'

export const useUpdateDocumentAppraisal = (
  options?: UseMutationOptions<
    ISiteBoxDocumentConfig,
    RequestErrorType,
    RequestTypes['updateDocumentAppraisal']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...siteBoxDocumentsKeys.updateDocumentAppraisal,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({
          documentId: variables.documentId,
        }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byConfigId._def,
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}
